['scroll', 'mousedown', 'mousemove', 'touchstart', 'keydown'].forEach(function (evt) {
  document.addEventListener(evt, onFirstInteraction, { once: true, passive: true });
});

function onFirstInteraction() {
  function loadCookieYes() {
    var el = document.createElement('script');
    el.src = 'https://cdn-cookieyes.com/client_data/1530db30ca086bc7942769f0/script.js';
    el.defer = true;
    document.body.appendChild(el);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadCookieYes);
  } else {
    setTimeout(loadCookieYes, 200);
  }
} 